module.exports = __webpack_public_path__ + "static/media/menu_manageServices_hoverActive.efcaeaba.svg";